export const getUserStore = state => state.locationStore.data;